module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap",
      "align-items": "center",
      "justify-content": "center",
      "width": "100vw",
      "z-index": "1000",
      "height": "100vh",
      "position": "fixed",
      "background-color": "#000000"
    },
    attrs: {
      "onload": this.getQuotes()
    }
  }, [_c('div', {
    staticClass: "loader-new"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader-quote"
  }, [_c('p', {
    staticClass: "quoteText"
  }, [_vm._v(_vm._s(_vm.currentQuote.text))]), _vm._v(" "), _c('p', {
    staticClass: "quoteAuthor"
  }, [_vm._v(_vm._s(_vm.currentQuote.author))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loader/loading-viewZzz.svg",
      "height": "30"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a8e550a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loader.vue
// module id = 841
// module chunks = 5